var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._b({staticStyle:{"cursor":"pointer","position":"relative"},on:{"click":_vm.getFullImage}},'v-avatar',_vm.$attrs,false),[(_vm.loading)?_c('v-progress-circular',{staticClass:"loader",attrs:{"size":50,"width":3,"color":"primary","indeterminate":""}}):_vm._e(),_c('img',{attrs:{"src":_vm.src,"alt":"thumbnail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }